/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createGetAiUsageResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type ErrorResponse, type GetAiUsageResponse, type InternalErrorResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/ai-usage
 */
export interface AiUsageRequestBuilder extends BaseRequestBuilder<AiUsageRequestBuilder> {
    /**
     * Returns the organization's AI usage totals and a breakdown by operation/model over a time window (defaults to the last 30 days).
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<GetAiUsageResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<AiUsageRequestBuilderGetQueryParameters> | undefined) : Promise<GetAiUsageResponse | undefined>;
    /**
     * Returns the organization's AI usage totals and a breakdown by operation/model over a time window (defaults to the last 30 days).
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<AiUsageRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Returns the organization's AI usage totals and a breakdown by operation/model over a time window (defaults to the last 30 days).
 */
export interface AiUsageRequestBuilderGetQueryParameters {
    /**
     * Start of the window (inclusive). Defaults to 30 days ago when omitted.
     */
    from?: Date;
    /**
     * End of the window (inclusive). Defaults to now when omitted.
     */
    to?: Date;
}
/**
 * Uri template for the request builder.
 */
export const AiUsageRequestBuilderUriTemplate = "{+baseurl}/api/organizations/ai-usage{?from*,to*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const AiUsageRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: AiUsageRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createGetAiUsageResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
